import { ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"

export function MaintenanceTaskElementSelectorCategoryItem({ item }) {
    const { categoryId, setCategoryId } = useBoundContext()
    const isSelected = categoryId === item.id
    const visibleTaskCount = getVisibleTaskCount()
    const isDirectory = item?.type === "directory"

    return (
        <ListItemButton dense selected={isSelected} onClick={handleClick} data-cy={`maintenance-category-${item.id}`}>
            <ListItemIcon sx={{ minWidth: 22 }}>
                <Iconify
                    icon={isDirectory ? "mdi:folder-outline" : "mdi:file-document-outline"}
                    width={18}
                    sx={{ color: isDirectory ? "warning.main" : "text.secondary" }}
                />
            </ListItemIcon>
            <ListItemText
                primary={item.name || "Untitled"}
                primaryTypographyProps={{
                    variant: "caption",
                    fontWeight: isDirectory ? 700 : 400,
                    noWrap: true,
                }}
            />
            <If value={typeof visibleTaskCount === "number"}>
                <Typography
                    variant="caption"
                    sx={{
                        color: "primary.main",
                        lineHeight: 1,
                        minWidth: 24,
                        textAlign: "right",
                    }}
                >
                    {visibleTaskCount}
                </Typography>
            </If>
        </ListItemButton>
    )

    function handleClick() {
        setCategoryId(item.id)
    }

    function getVisibleTaskCount() {
        if (typeof item.aggregateTaskCount === "number") return item.aggregateTaskCount
        if (typeof item.taskCount === "number") return item.taskCount
        return null
    }
}
